"use client"

import { usePathname } from "next/navigation"
import type { ReactNode } from "react"

/**
 * Thin client gate — hides the site footer on routes that provide their own
 * chrome (e.g. /test-alt-landing, /audit).
 */
export function SiteFooterGate({ children }: { children: ReactNode }) {
  const pathname = usePathname()
  if (pathname?.startsWith("/test-alt-landing")) return null
  // /audit a son propre footer (signature + avatar Allan) — pas de footer
  // global pour préserver l'aspect document de présentation.
  if (pathname?.startsWith("/audit")) return null
  return <>{children}</>
}
